<!-- Таблица -->

<template>

	<div ref="table_element" v-on:keyup.enter="apply_filters" class="elements-main main-container">

		<showAttr ref="show_attr" :custom_title="show_attrs_title" :plural="essence_name_for_plural_others" :service="service" />
		<setAttrMany ref="set_attr_many" :attrs="attrs_editable" :validation="attr_edit_many_validation" />
		<clearAttrMany ref="clear_attr_many" :service="service" :attrs="attrs_editable" v-on:need_refresh="() => refresh()"/>

		<slot name="modal_dialogs"/>

		<b-navbar class="px-0">

			<b-navbar-brand>

				<div v-if="has_history && ! without_back_button" class="d-flex align-items-center" style="gap: .75rem;">

					<b-button class="transparent" @click="go_back">

						<base-icon name="arrow long_left" />

					</b-button>

					<slot name="title"/>

				</div>

				<slot v-else name="title"/>

			</b-navbar-brand>

			<b-col align="right" class="d-flex justify-content-end p-0">

				<div v-if="with_simple_filter" :style="'display: inline-block; width: calc(50% - ( 35px + 0.75rem) * ' + ( is_sort ? '5' : '4' ) + ')'" class="mr-2">

					<b-input-group>

						<b-form-input size="sm" v-model="simple_query" placeholder="Поиск"/>
						
					</b-input-group>

				</div>

				<b-button v-if="with_simple_filter" size="sm" variant="outline-primary" class="mr-2 nav-button" v-b-tooltip:fullscreen.hover.bottomright title="Применить" v-on:click="() => apply_filters()"><b-icon-search/></b-button>

				<b-button v-if="with_simple_filter" size="sm" :variant="simple_query == '' || simple_query == null ? 'outline-primary' : 'primary'" :class="'mr-2 ' + ( ( simple_query == '' || simple_query == null ) ? 'nav-button' : '' )" v-b-tooltip:fullscreen.hover.bottomright title="Применить" v-on:click="() => { simple_query = null; apply_filters() }">

					<b-iconstack>

						<b-icon stacked icon="funnel"/>
						<b-icon stacked icon="slash"/>

					</b-iconstack>

				</b-button>

				<b-nav pills align="right">

					<slot name="first_nav_items"/>

					<b-button v-on:click="add_element" v-b-tooltip:fullscreen.hover.bottomright title="Добавить" variant="outline-primary" v-if="! without_add"><base-icon name="add" /></b-button>
					<b-button v-if="with_show_attrs" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright 
						:title="show_attrs_tooltip || ('Выбор характеристик' + (service === 'cadastral_analogues' ? ' и ценообразующих факторов' : ` ${essence_name_for_plural_others}`))"
						v-on:click="show_attr"
					>
						<base-icon name="settings" />
					</b-button>

					<b-dropdown variant="outline-primary" text="Множественное редактирование" v-b-tooltip:fullscreen.hover.bottomright="'Множественное редактирование'" v-if="with_attr_edit_many || $scopedSlots.many_edit_nav_items" right>

						<template #button-content>

							<base-icon name="pen" />

						</template>

						<b-dropdown-item v-if="! without_edit_many" v-on:click="set_attr_many">Параметр</b-dropdown-item>
						<b-dropdown-item v-if="with_clear_many" v-on:click="clear_attr_many">Сброс значений атрибута</b-dropdown-item>
						<b-dropdown-item v-if="with_delete_many" v-on:click="delete_many">Удаление объектов</b-dropdown-item>
						<slot name="many_edit_nav_items"/>

					</b-dropdown>

					<b-button v-b-tooltip:fullscreen.hover.bottomright v-if="with_filters" variant="outline-primary" title="Фильтр" @click="toggle">
						<base-icon :name="
								filter_opened ? 'filter_alt_close' : filter_button_colored ? 'filter_alt_active' : 'filter_alt'
							" />
					</b-button>

					<slot name="nav_items_before_export"/>
					
					<b-button v-on:click="export_to_table()" title="Экспорт таблицы" class="nav-button" v-b-tooltip:fullscreen.hover.bottomright variant="outline-primary" v-if="! without_export && !$root.readonly"><base-icon name="download" /></b-button>

					<slot name="nav_items"/>

					<b-button v-if="is_sort" size="sm" variant="outline-primary" class="nav-button" v-b-tooltip:fullscreen.hover.bottomright title="Сброс сортировки" v-on:click="clear_sort">
						<base-icon name="sort_cancel" />
					</b-button>

				</b-nav>

			</b-col>

		</b-navbar>

		<b-collapse id="query" ref="filters_container" v-model="filter_opened">

			<filters ref="filters" :essence="service" :attrs="attrs" :storage_name_filters="storage_name_filters" :storage_name_filters_name="storage_name_filters_name" :additional_rules="additional_rules" v-on:need_refresh="refresh_by_filters" :with_status_filter="with_status_filter" v-on:ready="filters_ready"/>

		</b-collapse>

		<!-- <v-context-menu v-if="!without_context_menu" ref="context_menu">

			<b-dropdown-item v-if="! without_details && single_element_url" v-on:click="$router.push('/' + single_element_url + '/' + selected_element.id)">Открыть</b-dropdown-item>
			<b-dropdown-item v-if="! without_details && single_element_url" v-on:click="() => open_in_new_tab('/' + single_element_url + '/' + selected_element.id)">Открыть в новой вкладке</b-dropdown-item>
			<b-dropdown-item v-if="! without_details && selected_element.show_url" :href="'/' + selected_element.show_url" target="_blank">Открыть в новой вкладке</b-dropdown-item>
			<b-dropdown-item v-if="! without_copy" v-on:click="() => $copyText(selected_text)">Копировать</b-dropdown-item>
			<b-dropdown-item v-if="! without_details && ! not_able_for_delete && ! selected_element.is_system" v-on:click="delete_element(selected_element)">Удалить</b-dropdown-item>
			<slot name="activities" :data="selected_element"/>

		</v-context-menu> -->

		<b-table
			v-if="is_filters_ready && attrs_ready_flag"
			ref="table"
			:busy="wait" class="elements" small
			:fields="attrs_visible"
			:items="elements"
			v-on:sort-changed="sort_changed" :sort-by="sort_by" :sort-desc="sort_desc" no-local-sorting
			v-on:row-dblclicked="double_click"
			@hook:mounted="table_init"
		>
			<!-- v-on:row-contextmenu="context_menu" -->

			<template #table-busy>

				<div class="text-center text-primary my-2">

					<b-spinner class="align-middle"></b-spinner>

				</div>

			</template>

			<template v-slot:head(edit)="data">

				<b-form-checkbox v-model="all_edit_checked" :id="data.field.key" :indeterminate="all_edit_indeterminate" v-on:change="all_edit_change"/>

			</template>

			<template v-slot:head(settings)="data">

				<div class="table_head_div" :id="data.field.key"><base-icon name="settings" /></div>

			</template>

			<template v-slot:head()="data">
				
				<div align-v="top" v-if="!data.field.without_head_label" :draggable="draggable" width="50px" v-on:dragstart="drag_column_begin" v-on:drop="drop_column" v-on:dragover="drag_column" :id="data.field.key" class="table_head_div">
					<slot v-if="$scopedSlots.table_head_params && data.field.head_params" name="table_head_params" :data="data" />
					<span v-else v-html="data.label"/>

				</div>
				<div align-v="top" v-else :draggable="draggable" width="50px" v-on:dragstart="drag_column_begin" v-on:drop="drop_column" v-on:dragover="drag_column" :id="data.field.key" class="table_head_div">
					
					<span></span>

				</div>

			</template>

			<template v-slot:cell()="data">
				
				<div v-if="$scopedSlots.table_cell_params && data.field.params" :class="data.field.type == 'number' && 'text-right '">

					<slot name="table_cell_params" :data="data"/>

				</div>

				<div v-else-if="data.field.key == 'edit'" class="table_div">

					<b-form-checkbox v-model="ids_for_edit" :value="data.item.id"/>

				</div>

				<div v-else-if="data.field.key == 'phones'" class="table_div">

					<div v-for="phone in data.item.phones" :key="phone"><a :href="`tel:${phone}`" target="_blank">{{ phone }}</a></div>

				</div>

				<div v-else-if="data.field.key == 'emails'" class="table_div">

					<div v-for="email in data.item.emails" :key="email"><a :href="`mailto:${email}`" target="_blank">{{ email }}</a></div>

				</div>

				<div v-else-if="data.field.key == 'address'" class="table_div">

					{{ data.item.address.index }} {{ data.item.address.address }}

				</div>

				<div v-else-if="data.field.key == 'passport'" class="table_div">

					{{ data.item.passport.series }} {{ data.item.passport.number }} <div v-if="data.item.passport.who">выдан {{ data.item.passport.who }} {{ data.item.passport.who_code }} {{ data.item.passport.when | format_date }}</div>

				</div>

				<div v-else-if="data.field.key == 'company_or_person_contact'" class="table_div">

					{{ data.item.contact.name }}<div v-if="data.item.contact.position"> {{ data.item.contact.position }}</div><div v-if="data.item.contact.attorney"> (доверенность {{ data.item.contact.attorney }} выдана {{ data.item.contact.date | format_date }})</div>

				</div>

				<div v-else-if="data.field.key == 'url'" class="table_div">

					<a :href="data.item.url" target="_blank">Открыть</a>

				</div>

				<div v-else-if="data.field.key == 'url_rosreestr'" class="table_div">

					<a :href="data.item.url_rosreestr" target="_blank">Открыть</a>

				</div>

				<div v-else-if="data.field.key == 'file'" class="table_div">

					<a :href="data.item.file.url" target="_blank">Открыть</a>

				</div>

				<div v-else-if="data.field.key == 'rosreestr'" class="table_div">

					<a v-if="data.item.rosreestr" :href="data.item.rosreestr.url" target="_blank">Открыть</a>

				</div>

				<div v-else-if="data.field.key == 'protocol'" class="table_div">

					<a v-if="data.item.protocol" :href="data.item.protocol.url" target="_blank">{{ data.item.protocol.name }}</a>

				</div>

				<div v-else-if="data.field.key == 'document'" class="table_div">

					<router-link :to="'/documents/' + data.item.document">Открыть</router-link>

				</div>

				<div v-else-if="data.field.key == 'group_name'" class="table_div">

					<router-link :to="'/group_statistic/' + data.item.group_id">{{ data.value }}</router-link>

				</div>

				<div v-else-if="data.field.key == 'documents.income'" class="table_div">

					<router-link v-if="data.item.documents.income != null" :to="'/documents/' + data.item.documents.income">Открыть</router-link>

				</div>

				<div v-else-if="data.field.key == 'documents.outcome'" class="table_div">

					<router-link v-if="data.item.documents.outcome != null" :to="'/documents/' + data.item.documents.outcome">Открыть</router-link>

				</div>

				<div v-else-if="data.field.key == 'status'" class="table_div">

					<div v-if="service == 'operations'">

						<div :id="'status' + data.item.id" v-if="data.item.execute && data.item.stage">

							{{ data.item.stage }} из {{ data.item.stages_count }} - {{ data.value }}

						</div>

						<b-tooltip v-if="data.item.execute" :target="'stat' + data.item.id" triggers="hover">

							Осталось: {{ data.value.time_to_finish }} с.

						</b-tooltip>

					</div>
					<div v-else>{{ data.value }}</div>

				</div>

				<div v-else-if="data.field.key == 'attr'" class="table_div">

					<router-link :to="'/attributes/' + data.value.id">{{ data.value.name }}</router-link>

				</div>

				<div v-else-if=" service == 'cadastral_analogues' && data.field.key == 'current_version.attrs.group_code'" class="table_div word-break-word">
				
					<div v-if="data.value != null && data.value != ''">
						
						<router-link :to="'/analogues/' + data.item.id">{{ data.value }}</router-link>

					</div>

				</div>

				<div v-else :class="(data.field.type == 'number' && 'text-right ') + 'table_div'">

					<div v-if="data.field.my_formatter" :let="desc = data.field.my_formatter(data, attrs_visible)">

						<div v-if="desc.html" v-html="desc.html"/>
						<div v-else :style="desc.style ? desc.style : ''">{{ desc.value }}</div>

					</div>
					<div v-else-if="data.field.type == 'array'">

						<div v-for="elem in data.value" :key="elem">

							<div v-if="data.field.reference">{{ format_reference(data.field, elem) }}</div>
							<div v-else>{{ elem }}</div>

						</div>

					</div>
					<div v-else-if="data.field.type == 'bool'">{{ data.value | format_bool }}</div>
					<div v-else-if="data.field.type == 'date'">{{ data.value | format_date }}</div>
					<div v-else-if="data.field.type == 'time'">{{ data.value | format_time }}</div>
					<div v-else-if="data.field.type == 'datetime'">{{ data.value | format_datetime }}</div>
					<div v-else-if="data.field.is_cadastral_number"><router-link :to="'/objects/cadastral_number/' + data.value">{{ data.value }}</router-link></div>
					<div v-else-if="data.field.reference">{{ format_reference(data.field, data.value) }}</div>
					<div v-else>{{ data.value }}</div>

				</div>

			</template>

		</b-table>

		<div class="footer">
			<div ref="footer_scroll" class="w-100 footer_scroll" style="overflow-x: auto;"><div v-if="tableWidth" :style="{ width: tableWidth + 'px', height: '1px' }"></div></div>
			<b-row class="footer_content small natural-400" style="font-size: 0.75rem" align-h="between">
			
				<b-col v-if="$slots.footer" cols="2">
	
					<slot name="footer"/>
	
				</b-col>
	
				<b-col cols="6">
	
						Найдено: {{count}} записей. Показывать на странице по:
						<v-select v-model="per_page" :options="[5, 10, 50]" @input="set_per_page" 
	:clearable="false" :searchable="false" class="v_select_up" style="width: 4.625rem;height: 1.5rem;display: inline-block" />
	
				</b-col>
	
				<b-col cols="4">
	
					<b-pagination ref="paginator" align="right" v-model="current_page" :per-page="per_page" :total-rows="count" aria-controls="table" v-on:change="refresh" first-number last-number>
						<template #prev-text><b-icon icon="chevron-left"></b-icon></template>     
						<template #next-text><b-icon icon="chevron-right"></b-icon></template>    
					</b-pagination>
	
				</b-col>
	
			</b-row>
		</div>


	</div>

</template>

<script>

import api from "../../api"
import showAttr from "./attrs/show"
import filters from "../filters"
import setAttrMany from "./attrs/set_many"
import clearAttrMany from "./attrs/clear_many"
import Table_controller from "../../api/table"
//import sub_menu from "../widgets/sub_menu"

export default
{
	components :
	{
		showAttr,
		filters,
		setAttrMany,
		clearAttrMany,
		//sub_menu,
	},

	props :
	{
		single_element_url : { type : String, default : () => "" },
		service : String,
		attrs : Array,
		additional_query : { type : Object, default : () => {} },
		raw_query : { type : Object, default : () => {} },
		get_many_extra : { type : Object, default : () => {} },
		title : String,
		essence_name_genetive_case : String, // Родительный падеж названия сущности, с маленькой буквы
		essence_name_for_plural_1 : String, // Родительный падеж, множественное число, 1 элемент, с маленькой буквы
		essence_name_for_plural_234 : String, // Родительный падеж, множественное число, 2, 3, 4 элемента, с маленькой буквы
		essence_name_for_plural_others : String, // Родительный падеж, множественное число, 5 и больше элементов, 0 элементов, с маленькой буквы
		without_add : Boolean,
		without_back_button : { type : Boolean, default : () => false },
		attrs_ready : { type : Promise, default : () => new Promise(resolve => resolve()) },
		many_edit : Boolean,
		not_able_for_delete : Boolean,
		initial_per_page : String,
		initial_sort_by : String,
		initial_sort_desc : { type : Boolean, default : () => true },
		delete_as_operation : Boolean,
		delete_message : { type : Function, default : plural_1 => new Promise(resolve => resolve("Вы действительно хотите удалить " + plural_1 + "?" ))},
		without_details : { type : Boolean, default : () => false },
		with_import_add : { type : Boolean, default : () => false },
		with_import_edit : { type : Boolean, default : () => false },
		without_export : { type : Boolean, default : () => false },
		with_attr_edit_many : { type : Boolean, default : () => false },
		attr_edit_many_validation : { type : Object, default : () => null },
		with_clear_many : { type : Boolean, default : () => false },
		without_edit_many : { type : Boolean, default : () => false },
		with_delete_many : { type : Boolean, default : () => false },
		with_status_filter : { type : Boolean, default : () => false },

		with_show_attrs : { type : Boolean, default : () => true },
		show_attrs_tooltip : { type : String, default : null },
		show_attrs_title : { type : String, default : null },

		with_filters : { type : Boolean, default : () => true },
		with_simple_filter : Boolean,
		without_context_menu : { type : Boolean, default : () => false },
		emit_on_double_click_element : { type : Boolean, default : () => false },
		export_to_xlsx_extra : { type : Object, default : () => {} },
		export_attrs_visible : { type : Boolean, default : () => false },
		additional_rules : { type : Array, default : () => [] },
		elements_table_height : { type : String, default : () => "80vh" },
		postfix_for_storage_name : String, // default == null
		draggable : { type : Boolean, default : () => true },
		without_copy : { type : Boolean, default : () => false },
		with_message_on_empty_get_many : Boolean,
		resizable : { type : Boolean, default : () => true },
	},

	data()
	{
		return {

			attrs_editable : [],

			attrs_visible : [],
			attrs_visible_if_no_visible : [],

			elements : [],
			selected_element : {},
			selected_text : null,
			ids_for_edit : [],
			all_edit_checked : false,
			all_edit_indeterminate : false,

			simple_query : null,

			is_sort : false,
			sort_by : null,
			sort_desc : null,
			count : 0,
			element_word : "",
			from : 0,
			to : 0,
			per_page : 0,
			current_page : 1,
			attrs_ready_flag : false,

			drag_column_id : null,

			filter_button_colored : false,
			filter_opened : false,
			wait : false,
			is_filters_ready : false,

			tableWidth: null

		}
	},

	watch :
	{
		attrs :
		{
			immediate : true,
			
			handler(attrs)
			{
				this.attrs_editable = attrs.filter(attr => attr.editable)
			}
		},

		attrs_visible :
		{
			immediate : true,

			handler(attrs_visible)
			{
				if(this.$refs.table != null)
					this.$nextTick(
						() =>
						{
							this.$emit("attrs_visible_changed", attrs_visible)
						})
				else
					this.$emit("attrs_visible_changed", attrs_visible)
			},
		},

		ids_for_edit(ids)
		{
			this.$emit("change_ids_for_edit", ids)

			if (ids.length === 0) {
				this.all_edit_checked = false
				this.all_edit_indeterminate = false
			} else if (ids.length === this.count) {
				this.all_edit_checked = true
				this.all_edit_indeterminate = false
			}else {
				this.all_edit_checked = false
				this.all_edit_indeterminate = true
			}
		}
	},

	computed :
	{
		has_history()
		{
			return this.$router.history.current.path != this.$router.history._startLocation
			// return window.history.length > 1
		},

		storage_name_filters()
		{
			return api.storage.name(this, "filters" + this.postfix_for_storage_name)
		},

		storage_name_filters_name()
		{
			return api.storage.name(this, "filters_name" + this.postfix_for_storage_name)
		},
	},

	filters :
	{
		format_float(value)
		{
			if(value != null)
				return value.toFixed(2)
		},

		format_bool(value)
		{
			return api.format_bool(value)
		},

		format_date(value)
		{
			return api.format_date(value)
		},

		format_time(value)
		{
			return api.format_time(value)
		},

		format_datetime(value)
		{
			return api.format_datetime(value)
		},
	},

	mounted()
	{
		const data = api.cache.paginator.load(this)

		if(data.current_page == null)
			this.current_page = 1
		else
			this.current_page = data.current_page

		if(this.initial_per_page == null)
			this.per_page = ( data.per_page == null ) ? 10 : data.per_page
		else
			this.per_page = Number(this.initial_per_page)

		var sort_context = {
			sortBy : null,
			sortDesc : null
		}

		if(data.sort_by != null && data.sort_by != this.initial_sort_by)
		{
			this.is_sort = true
			sort_context.sortBy = data.sort_by
			sort_context.sortDesc = data.sort_desc
		}
		else if(this.initial_sort_by != null)
		{
			sort_context.sortBy = this.initial_sort_by

			if(this.initial_sort_desc == null)
				sort_context.sortDesc = false
			else
				sort_context.sortDesc = this.initial_sort_desc
		}

		this.change_sort(sort_context)

		return this.attrs_ready
	},

	beforeUpdate()
	{
		this.save_to_storage()
	},

	beforeDestroy()
	{
		this.save_to_storage()
	},

	methods :
	{
		toggle()
		{
			this.filter_opened = !this.filter_opened
		},

		format_reference(attr, value)
		{
			if(attr.reference)
			{
				if(attr.reference.simple_values)
				{
					const found = attr.reference.simple_values.find(elem => elem.value == value)

					if(found)
						return found.label
				}
				else
					return api.format_reference(attr.reference, value)
			}

			return value
		},

		save_to_storage()
		{
			if(this.attrs_ready_flag && this.with_show_attrs)
				api.storage.set(this, api.storage.name(this, "attr_visible_keys" + this.postfix_for_storage_name), JSON.stringify(this.attrs_visible.map(attr => attr.key)))
		},

		get_query(and_query = null, new_query = false, force_with_filters = false)
		{
			if(this.with_filters || force_with_filters)
			{
				this.filter_button_colored = this.$refs.filters.applied

				return this.$refs.filters.get_query(this.additional_query, this.raw_query, true, {}, and_query, ! new_query)
			}
			else if(this.with_simple_filter)
			{
				if(this.simple_query == null || this.simple_query == "")
					return {}
				else
					return this.simple_query
			}
			else
				return {}
		},

		go_back()
		{
			api.back.go(this)
		},

		refresh_by_filters()
		{
			this.$refs.filters_container.toggle()
			this.$refs.filters.save_to_local_storage()
			this.refresh(1, true)
		},

		refresh(current_page = 1, is_button_pressed = false, and_query = null, force_with_filters = false)
		{
			this.wait = true

			const skip = (current_page - 1) * this.per_page // Бек нумерует с 0
			const query = this.get_query(and_query, is_button_pressed, force_with_filters)
			const params_count = { query : query, extra : this.get_many_extra }
			var params = { query : query, skip : skip, extra : this.get_many_extra }

			if(this.per_page > 0)
				params.limit = this.per_page

			if(this.sort_by != null && this.sort_by != "")
			{
				const attr = this.attrs.find(attr => attr.key == this.sort_by)

				params.sort_by = this.sort_by
				params.is_desc = this.sort_desc

				if(attr != null)
				{
					if(attr.sort_by_key != null)
						params.sort_by = attr.sort_by_key

					if(params.extra == null || params.extra == undefined)
						params.extra = {}
					else
						params.extra = api.deep_clone(params.extra)

					params.extra.sort_type = attr.type
				}
			}

			const data = {
					current_page : current_page,
					per_page : this.per_page,
					sort_by : this.sort_by,
					sort_desc : this.sort_desc,
				}
			api.cache.paginator.save(this, data)

			return api.call(this, this.$props.service, "get_many", params,
				response =>
				{
					this.elements = response.data

					if(this.elements.length == 0 && this.with_message_on_empty_get_many)
						api.show_notification(this, "Объекты, соответствующие заданным условиям фильтрации, не найдены")

					if(skip == 0 && this.elements.length == 0)
					{
						this.from = 0
						this.to = 0
					}
					else
					{
						this.from = skip + 1 // Отображаемая нумерация с 1
						this.to = this.from + this.elements.length - 1
					}
				})
				.then(
					() =>
					{
						this.wait = false

						this.$emit("refresh")
					})
				.then(
					api.call(this, this.$props.service, "get_many_count", params_count,
						response =>
						{
							this.count = response.count
							this.element_word = this.get_element_word(this.count)
							this.current_page = current_page

							try
							{
								this.$refs.paginator.currentPage = current_page
							}
							// eslint-disable-next-line
							catch {}
						},
						( self, response ) =>
						{
							if(response.exception == "BadRegexp")
								return

							return api.show_error_box(self, response)
						})
				)
		},

		table_init()
		{
			if(this.resizable)
			{
				this.table_controller = new Table_controller(this, this.$refs.table.$el, this.$refs.table_element.clientWidth)
			}

			new ResizeObserver((entries) => {
				this.tableWidth = entries[0].target.clientWidth
			}).observe(this.$refs.table.$el)

			new ResizeObserver(() => {
				if (this.$refs.table && this.table_controller)
				{
					this.table_controller.resize(this.$refs.table_element.clientWidth)
				}
			}).observe(this.$el)
		
			this.$refs.footer_scroll && this.$refs.footer_scroll.addEventListener('scroll', (e) => {
				this.$refs.table.$el.style.transform = `translateX(${-e.target.scrollLeft}px)`
			})
		},

		set_resizable_and_width()
		{
			if (this.table_controller)
			{
				this.table_controller.set_width()
			}
		},

		reset_table_width()
		{
			if (this.table_controller)
			{
				this.table_controller.reset()
			}
		},

		clear_sort()
		{
			this.is_sort = false
			this.sort_by = this.initial_sort_by
			this.sort_desc = this.initial_sort_desc

			return this.refresh()
		},

		change_sort(ctx)
		{
			var attr_for_sorting

			if(ctx.sortBy == "$natural")
				attr_for_sorting = { key : "$natural" }
			else
				attr_for_sorting = this.attrs.find(elem => elem.key == ctx.sortBy)

			if(attr_for_sorting)
			{
				if(attr_for_sorting.key_for_sort != null)
					this.sort_by = attr_for_sorting.key_for_sort
				else
					this.sort_by = attr_for_sorting.key

				this.sort_desc = ctx.sortDesc
			}
		},

		sort_changed(ctx)
		{
			if(! this.is_sort)
			{
				this.is_sort = true
			}

			this.change_sort(ctx)
			this.refresh()
		},

		set_per_page(per_page)
		{
			this.per_page = per_page
			this.current_page = 1

			this.refresh()
		},

		get_element_word(count)
		{
			return api.words.element.accusative(count, this.$props.essence_name_for_plural_1, this.$props.essence_name_for_plural_234, this.$props.essence_name_for_plural_others)
		},

		add_element()
		{
			if(this.$scopedSlots.modal_dialogs == null)
			{
				this.wait = true

				api.call(this, this.service, "add", { data : {} }, () => this.refresh()).then(() => { this.wait = false })
			}
			else
				this.$scopedSlots.modal_dialogs()[0].context.$refs.add_element.execute()
		},

		delete_element(elem)
		{
			this.delete_message(this.essence_name_for_plural_1, elem)
				.then(
					message =>
					{
						this.$bvModal.msgBoxConfirm(
							message,
							{
								title : "Подтверждение удаления",
								okVariant : "danger",
								okTitle : "Да",
								cancelVariant : "outline-primary-secondary",
								cancelTitle : "Нет",
								hideHeaderClose : false,
								centered : true
							})
							.then(
								value =>
								{
									if(value)
									{
										var promise

										if(this.delete_as_operation)
										{
											api.call_long_operation(this, "Удаление " + this.essence_name_genetive_case, this.service, "delete", { id : elem.id }, () => this.refresh())
											promise = new Promise(resolve => resolve())
										}
										else
										{
											this.wait = true

											promise = api.call(this, this.service, "delete", { id : elem.id }, () => this.refresh())
										}

										promise.then(
											() =>
											{
												this.$emit("delete_one")

												this.wait = false
											})
									}
								})
					})
		},

		delete_many()
		{
			this.$bvModal.msgBoxConfirm(
				"Удалить " + this.count + " " + this.get_element_word(this.count) + "?",
				{
					title : "Подтверждение удаления",
					okVariant : "danger",
					okTitle : "Да",
					cancelVariant : "outline-primary-secondary",
					cancelTitle : "Нет",
					hideHeaderClose : false,
					centered : true
				})
				.then(
					value =>
					{
						if(value)
						{
							if(this.delete_as_operation)
							{
								api.call_long_operation(this, "Удаление " + this.essence_name_for_plural_others, this.service, "delete_many", { query : this.get_query() },
									() =>
									{
										this.$emit("delete_many")

										this.refresh()
									},
									{ success_msg : "Выбранные данные удалены" }
								)
							}
							else
							{
								this.wait = true

								api.call(this, this.service, "delete_many", { query : this.get_query() },
								() =>
								{
									api.show_notification(this, "Выбранные данные удалены")
									this.$emit("delete_many")

									this.wait = false
									this.refresh()
								})
							}
						}
					})
		},

		all_edit_change(value)
		{
			this.ids_for_edit = []

			if(value)
				this.elements.forEach(elem => this.ids_for_edit.push(elem.id))
		},

		drag_column_begin(event)
		{
			this.drag_column_id = event.srcElement.id
		},

		drag_column(event)
		{
			event.preventDefault();
		},

		drop_column(event)
		{
			var to_column_id = event.srcElement.id

			var drag_id = null
			var to_id = null

			this.attrs_visible.forEach(
				( elem, index ) =>
				{
					if(elem.key == this.drag_column_id)
						drag_id = index

					if(elem.key == to_column_id || elem.label == event.srcElement.innerText)
						to_id = index
				})

			var drag_attr = this.attrs_visible[drag_id]

			if(drag_id < to_id)
			{
				this.attrs_visible.splice(to_id + 1, 0, drag_attr)
				this.attrs_visible.splice(drag_id, 1)
			}
			else
			{
				this.attrs_visible.splice(to_id, 0, drag_attr)
				this.attrs_visible.splice(drag_id + 1, 1)
			}
		},

		context_menu(selected_element, index, event)
		{
			event.preventDefault()

			if(this.without_context_menu)
				return

			this.selected_element = selected_element
			this.selected_text = event.srcElement.innerText
			this.$refs.context_menu.open(event)
		},

		double_click(selected_element)
		{
			if(this.single_element_url)
				this.$router.push('/' + this.single_element_url + '/' + selected_element.id)

			if(selected_element.show_url)
				this.$router.push('/' + selected_element.show_url)

			if(this.emit_on_double_click_element)
				this.$emit("double_click_element", selected_element)
		},

		open_in_new_tab(url)
		{
			window.open(url, "_blank")
		},

		// ############################################################################
		// Атрибуты

		show_attr()
		{
			this.$refs.show_attr.execute()
		},

		// #############################################################################
		// Импорт, экспорт

		export_to_table()
		{
			var params = {
				query : this.get_query(),
				query_extra : this.get_many_extra,
				extra : this.export_to_xlsx_extra,
			}

			if(this.service == "cadastral_objects" || this.service == "cadastral_analogues")
			{
				params.type = "table"
				params.attrs = []

				this.attrs_visible.forEach(attr => params.attrs.push(attr.key.replace("current_version.", "")))
			}
			else if(this.service == "cadastral_expensive_details" || this.service == "cadastral_profitable_details")
			{
				if(params.extra == null)
					params.extra = {}

				params.extra.attrs = []

				this.attrs_visible.forEach(attr => params.extra.attrs.push(attr.key))
			}
			else if (this.export_attrs_visible)
			{
				params.extra = { attrs : [] }

				this.attrs_visible.forEach(attr => {
					if (attr.key != "edit" && attr.label != "")
					{
						params.extra.attrs.push(attr.key)
					}
				})
			}

			api.call_long_operation(this, "Экспорт запущен", this.$props.service, "export", params, api.open_response_url, { success_msg : "Экспорт таблицы завершен" })
		},

		// #############################################################################
		// Фильтры

		filters_ready()
		{
			this.$refs.filters.refresh()
				.then(
					() =>
					{
						const prev_attr_visible_keys = api.storage.get(this, api.storage.name(this, "attr_visible_keys" + this.postfix_for_storage_name), [], Array)
						var attrs_visible = []

						if(prev_attr_visible_keys.length)
						{
							prev_attr_visible_keys.forEach(
								key =>
								{
									var attr = this.attrs.find(attr => attr.key == key)

									if(attr)
										attrs_visible.push(attr)
								})
						}
						else
							attrs_visible = this.attrs.filter(attr => attr.visible)

						this.attrs_visible = attrs_visible

						if(this.many_edit)
							this.attrs_visible.splice(0, 0,
							{
								key : "edit",
								label : "",
								tdClass : "cell_checkbox",
								thClass : "cell_checkbox",
								thStyle : "width: 56px;"
							})

						this.attrs_visible_if_no_visible = this.attrs.filter(attr => attr.visible_if_no_visible)
						this.attrs_ready_flag = true
					})
				.then(
					() =>
					/*
					{
						const name = this.$route.params.name
						var query = this.$route.params.query

						if(query == null)
							query = this.$route.query.query

						if(query == null || ( api.back.check(this) && this.$refs.filters.exist_tab_local() ))
							this.$refs.filters.load_from_local_storage(false)
						else
							this.$refs.filters.load_from_foreign_storage({ name : name, query : query }, false)
					})*/
					{
						const name = this.$route.params.name
						var query = this.$route.params.query
						const from_post_query = query != null
						var result = false
						var force = false

						if(query == null)
						{
							query = this.$route.query.query
							force = this.$route.query.force
						}

						if(force && query != null)
							this.$refs.filters.load_from_foreign_storage({ name : name, query : query }, false)
						else
						{
							if(! from_post_query)
								result = this.$refs.filters.load_from_local_storage(false)

							if(! result && query != null)
								this.$refs.filters.load_from_foreign_storage({ name : name, query : query }, false)
						}
					})
				.then(
					() => this.refresh(this.current_page, true)
						.then(
							() =>
							{
								this.is_filters_ready = true
								this.$emit("filters_ready")
							})
					)
		},

		apply_filters()
		{
			const modal_count = this.$el.querySelectorAll(".modal.in").length + this.$el.querySelectorAll("div .vm--modal").length

			if(this.with_filters)
			{
				if(modal_count == 0)
					this.$refs.filters.apply()
			}
			else if(this.with_simple_filter)
				this.refresh()
		},

		// #############################################################################
		// Множественное редактирование

		set_attr_many()
		{
			this.$refs.set_attr_many.execute()
		},

		clear_attr_many()
		{
			this.$refs.clear_attr_many.execute()
		},
	}
}

</script>

<style scoped>
* >>> .cell_checkbox .custom-checkbox
{
	padding-left: 24px;
	width: 0;
}
* >>> .cell_checkbox .custom-control-label::before
{
	left: -24px;
}
.elements-main
{
	height: unset;
	flex: 1;
	overflow-x: clip;
}
.elements-main:hover .footer_scroll::-webkit-scrollbar-thumb
{
	background-color: var(--bft-neutral-300) !important;
}
@-moz-document url-prefix() {
	.elements-main:hover .footer_scroll
	{
		scrollbar-color: var(--bft-neutral-300) transparent;
	}
}
.elements-main .navbar
{
	position: sticky;
	top: 0;
}
.elements-main .elements
{
	min-width: 100%;
}
.elements-main .elements >>> thead
{
	position: sticky;
	top: 56px;
	z-index: 1;
}
.elements-main .footer
{
	margin-top: auto;
	bottom: 0;
	position: sticky;
	background-color: white;
	z-index: 1;
}
.elements-main .footer_content
{
	padding-top: 1rem;
}
</style>

<style>
.elements-main .elements .custom-checkbox
{
	z-index: 0;
}
</style>
